import Card from "@material-tailwind/react/Card";
import CardBody from "@material-tailwind/react/CardBody";
import { useHistory } from "react-router-dom";
import DataTable from "react-data-table-component";


export default function CardTable({ agentGrowth,
  pending,
  totalRows,
  handlePageChange,
  handlePerRowsChange,
  perPage
}) {
  const filteredItems = agentGrowth;
  const columns = [
    {
      name: "Date",
    //   width: '150px',
      selector: (row, index) => row.date,
      sortable: true,
      center: true
    },
    {
      name: "New Register",
    //   width: '150px',
      selector: (row, index) => row.total_register,
      sortable: true,
      right: true
    },
    {
      name: "Active Player",
    //   width: '150px',
      selector: (row, index) => row.active_player,
      sortable: true,
      right: true
    },
    {
      name: "Deposit",
    //   width: '150px',
      selector: (row, index) => row.total_deposit,
      sortable: true,
      right: true
    },
    {
      name: "Deposit Amount",
    //   width: '120px',
      selector: (row, index) => row.deposit_amount,
      sortable: true,
      right: true
    },
    {
      name: "Withdraw",
    //   width: '180px',
      selector: (row) => row.total_withdraw,
      sortable: true,
      right: true
    },
    {
      name: "Withdraw Amount",
    //   width: '150px',
      selector: (row, index) => row.withdraw_amount,
      sortable: true,
      right: true
    },
    {
      name: "First Deposit",
    //   width: '150px',
      selector: (row, index) => row.total_first_deposit,
      sortable: true,
      right: true
    },
    {
      name: "First Deposit Amount",
    //   width: '150px',
      selector: (row, index) => row.first_deposit_amount,
      sortable: true,
      right: true
    },
  ];

  return (
    <>
      <Card className="mt-10">
        <CardBody>
          <DataTable
            columns={columns}
            data={filteredItems}
            // pagination
            // paginationServer
            // paginationTotalRows={totalRows}
            // onChangePage={handlePageChange}
            // onChangeRowsPerPage={handlePerRowsChange}
            // paginationPerPage={perPage}
            // paginationRowsPerPageOptions={[10, 100, 500, 1000]}
          />
        </CardBody>
      </Card >
    </>
  );
}
